import React, { useEffect, useState } from "react";
import { SelectAddress } from "@secondcloset/web-components";

// Libs
import Address from "../../../../lib/address";

// Hooks
import { useCustomerAddresses, useCustomerAddressCreate } from "hooks/api/fulfillment/customer";
import useOrderCreateFlow from "hooks/reduxContainer/fulfillment/orderCreateFlow";

// Interface
import { Fulfillment } from "@secondcloset/types";
type CustomerAddress = Fulfillment.CustomerAddress;
interface AddressFormValues extends CustomerAddress {
  unit?: string;
  contact_name: string;
  phone_number: string;
}

const SelectAddressStep = () => {
  const [customerAddresses, setCustomerAddresses] = useState<CustomerAddress[]>([]);
  const { fetchCustomerAddresses } = useCustomerAddresses();
  const { createCustomerAddress } = useCustomerAddressCreate();
  const { activeAddress, activeCustomer, dispatchActiveAddress } = useOrderCreateFlow();

  useEffect(() => {
    (async () => {
      const addresses = await fetchCustomerAddresses(activeCustomer?.id);
      setCustomerAddresses(addresses);
    })();
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [activeCustomer]);

  const handleCreateCustomerAddress = async (address: AddressFormValues) => {
    const { addresses } = (await createCustomerAddress(activeCustomer?.id, address)) as {
      addresses: CustomerAddress[];
    };
    setCustomerAddresses(addresses);
    const latestAddress = Address.getLatestAddress(addresses);
    dispatchActiveAddress(latestAddress);
  };

  return activeCustomer ? (
    <SelectAddress
      customer={activeCustomer}
      selectedAddress={activeAddress as CustomerAddress}
      customerAddresses={customerAddresses ?? []}
      createCustomerAddress={handleCreateCustomerAddress}
      onAddressSelect={dispatchActiveAddress}
    />
  ) : null;
};

export default SelectAddressStep;
